import React from "react";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixConfirmationProps } from "../types";

const PixConfirmation: React.FC<PixConfirmationProps> = ({ amount }) => {
  const classes = usePixModalStyles();

  const formatted = amount.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className={classes.confirmationBox}>
      <div className={classes.confirmIcon}>
        <CheckCircleOutlineIcon style={{ fontSize: 32 }} />
      </div>
      <div className={classes.confirmTitle}>Pagamento Confirmado!</div>
      <div className={classes.confirmText}>
        Seu pedido foi liberado e está em processamento para entrega.
      </div>
      <div className={classes.valorPagoCard}>
        <div className={classes.valorPagoLabel}>VALOR PAGO</div>
        <div className={classes.valorPagoAmount}>R$ {formatted}</div>
      </div>
    </div>
  );
};

export default PixConfirmation;
